import { css } from '@/styled-system/css';

// Converted from styled-components to PandaCSS
export const flexContainerStyles = css({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  gap: 'sm 0',
  justifyContent: 'space-between',
});

export const flexRowStyles = css({
  flexBasis: '100%',
  paddingRight: '{spacing.none}',
  marginBottom: '{spacing.layout.tight} !important',

  '@media (min-width: 769px)': {
    /* 2x2 grid */
    flexBasis: '50%',
    /* not sure why we need !important here */
    paddingRight: '{spacing.tighter} !important',
    '&:nth-child(2n)': {
      paddingRight: '{spacing.none}',
    },
  },
});
